module.exports = __webpack_public_path__ + "static/media/covid-shield.9a0b1690.svg";